/* Clinq Zero: Dallas and DFW cold-delivery prompt.
   Shown only to visitors an IP lookup places inside our delivery ZIP codes.
   Built 11 October 2026.

   - The ZIP test is the SAME prefix list the delivery page uses, so the prompt
     and the checkout gate can never disagree.
   - One lookup per visitor, cached 7 days, fired when the page is idle.
   - Hides the Klaviyo quiz pop-up for DFW visitors, so nobody gets two.
   - Silent on any failure. No prompt beats a wrong prompt. */
(function(){
  'use strict';
  var KEY   = 'czdfw.geo';
  var SEEN  = 'czdfw.seen';    /* dismissed or clicked through */
  var SHOWN = 'czdfw.shown';   /* displayed and ignored        */
  var TTL   = 1  * 864e5;      /* re-check where she is once a day   */
  var AGAIN = 30 * 864e5;      /* dismissed: leave her alone a month  */
  var REST  = 1  * 864e5;      /* shown and ignored: offer it again tomorrow,
                                  but never twice in the same day     */

  var ZIP_PREFIX  = ['750','751','752','760','761'];
  var ZIP_ALLOW   = ['76201'];

  /* Only the ZIPs that are genuinely OUTSIDE the delivery radius: Sherman and
     Denison. The delivery page also blocks PO-box ZIPs (75026, 75086, 75221,
     75222, 75250, 75270) because you cannot hand a bottle to a PO box, but an
     IP that maps to one of those still belongs to somebody standing in Dallas,
     and ipapi returns 75270 for a good share of downtown. Blocking them here
     hid the prompt from real locals. She enters her real delivery ZIP on the
     page, where the full check still runs. */
  var ZIP_BLOCKED = ['75020','75021','75090','75091','75092'];

  var SKIP = ['/pages/delivered-cold-dallas',
              '/pages/is-non-alcoholic-sparkling-wine-for-you',
              '/pages/should-i-plan-a-dry-month'];

  function store(k){ try { return JSON.parse(localStorage.getItem(k)); } catch(e){ return null; } }
  function keep(k,v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} }

  function inArea(zip){
    if(!zip) { return false; }
    zip = String(zip).trim().slice(0,5);
    if(!/^[0-9]{5}$/.test(zip))        { return false; }
    if(ZIP_ALLOW.indexOf(zip)   > -1)  { return true;  }
    if(ZIP_BLOCKED.indexOf(zip) > -1)  { return false; }
    return ZIP_PREFIX.indexOf(zip.slice(0,3)) > -1;
  }

  function init(){
    var path = window.location.pathname;
    for(var i=0;i<SKIP.length;i++){ if(path.indexOf(SKIP[i]) === 0){ return; } }

    var el = document.getElementById('czdfw');
    if(!el){ return; }

    function dismiss(){
      keep(SEEN, Date.now());
      el.classList.remove('on');
      setTimeout(function(){ el.hidden = true; }, 280);
    }

    el.querySelector('.czdfw-x').addEventListener('click', dismiss);
    el.querySelector('.czdfw-no').addEventListener('click', dismiss);
    el.querySelector('.czdfw-btn').addEventListener('click', function(){ keep(SEEN, Date.now()); });

    /* A DFW visitor gets this instead of the quiz pop-up, never both. */
    function quietKlaviyo(){
      var css = document.createElement('style');
      css.textContent = '.klaviyo-form,div[class*="kl-private-reset-css"]{display:none !important}';
      document.head.appendChild(css);
    }

    function show(){
      quietKlaviyo();
      el.hidden = false;
      /* setTimeout rather than requestAnimationFrame: rAF does not run in a
         background tab, which would leave the card at opacity 0 on desktop. */
      setTimeout(function(){ el.classList.add('on'); }, 30);
      if(window.gtag){ window.gtag('event','dfw_prompt_shown'); }
    }

    function decide(geo){
      if(!geo){ return; }
      if(geo.country && geo.country !== 'US'){ return; }
      if(!inArea(geo.postal)){ return; }   /* outside DFW: the quiz pop-up runs untouched */

      /* A local gets the delivery prompt instead of the quiz pop-up, and keeps
         getting the delivery prompt instead of it even after dismissing one. */
      quietKlaviyo();

      var seen = store(SEEN);
      if(seen && (Date.now() - seen) < AGAIN){ return; }   /* dismissed or clicked */

      var shown = store(SHOWN);
      if(shown && (Date.now() - shown) < REST){ return; }  /* shown already, do not nag page to page */

      keep(SHOWN, Date.now());
      show();
    }

    var cached = store(KEY);
    if(cached && cached.at && (Date.now() - cached.at) < TTL){
      decide(cached);
      return;
    }

    function lookup(){
      var done  = false;
      var timer = setTimeout(function(){ done = true; }, 3500);
      fetch('https://ipapi.co/json/', { mode:'cors', credentials:'omit' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          if(done || !j){ return; }
          clearTimeout(timer);
          var geo = { postal: j.postal, country: j.country_code, at: Date.now() };
          keep(KEY, geo);
          decide(geo);
        })
        .catch(function(){ /* silent */ });
    }

    if('requestIdleCallback' in window){ requestIdleCallback(lookup, { timeout: 4000 }); }
    else { setTimeout(lookup, 2200); }
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
